import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import { LeavingSiteIcon } from 'components/icons'

export const ExternalStoreBuyButton = ({
  openRedirectModal,
  size,
  storeDisplayName,
  style,
  url,
  viglinkEnabled,
  ...rest
}) => {
  const openModal = openRedirectModal && url

  const handleClick = () => {
    openRedirectModal({
      url,
      storeDisplayName,
      isShopRegistryView: true,
    })
  }

  return (
    <InfoButton
      href={openModal ? undefined : url}
      newWindow
      onClick={openModal ? handleClick : undefined}
      pill
      size={size}
      style={style || { minWidth: 137 }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <span className="mrm">Buy</span>
      <LeavingSiteIcon style={{ position: 'relative', top: -2 }} />
    </InfoButton>
  )
}

ExternalStoreBuyButton.propTypes = {
  openRedirectModal: PropTypes.func,
  url: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  storeDisplayName: PropTypes.string,
  style: PropTypes.object,
  viglinkEnabled: PropTypes.bool,
}

ExternalStoreBuyButton.defaultProps = {
  openRedirectModal: null,
  size: undefined,
  storeDisplayName: null,
  style: undefined,
  viglinkEnabled: false,
}
